export default {
  TITLE: `Schedule issues`,
  SUMMARY: ``,
  INFORMATIONS: `Informations`,
  ISSUES: `Issues`,
  FILTER: `Filter`,
  SELECT_DATE_RANGE: `Please select a date range.`,
  SHOW_RESOLVED_ISSUES: `Show resolved shifts`,
  NO_PERMISSION: `Missing permissions to see issues`,
  RESOLVE: `Resolve`,
  RESOLVED: `Resolved`,
  UN_RESOLVE: `Undo resolve`,
  DATE: `Date: `,
  NAME: `Name: `,
  POSITION: `Position: `,
  EDIT_SHIFT: `Edit shift`,
  EDIT_POSITION: `Edit position`,
  EDIT_USER: `Edit user`,
  PROJECTS: `Projects: `
}
